import api from "@/api/api-v2-config";

export async function getNoteAxios() {    
    return await api.get("notes");
}

export async function deleteNoteAxios(id) {    
    return await api.delete("notes/"+ id);
}

export async function postNoteAxios(item) {    
    return await api.post("notes", item);
}

export async function putNoteAxios(item) {    
    return await api.put("notes", item);
}

export async function getNoteByIDAxios(id) {    
    return await api.get("notes/", id);
}

export async function getNoteByLeadIDAxios(leadid) {    
    return await api.get("notes/byleadclientid/"+ leadid);
}